export default __webpack_public_path__ + "2aa53df49715befe3c43c5e5ff6c4078.png";